// extracted by mini-css-extract-plugin
export default {"container":"wol_Ol"};